module.exports = __webpack_public_path__ + "img/ads1.cee203ed.jpg";